import { Controller } from "@hotwired/stimulus"

// Burger menu in the marketing nav. Toggles the dropdown panel and closes it
// on outside click, Escape, or before Turbo caches the page (so a restored
// page never comes back with the menu stuck open).
export default class extends Controller {
  static targets = ["button", "panel", "openIcon", "closeIcon"]

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    this.openIconTarget.hidden = true
    this.closeIconTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.panelTarget.hidden = true
    this.openIconTarget.hidden = false
    this.closeIconTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
